export function addressIsEmpty(routePoint: EditableRoutePointState): boolean {
  const location = routePoint.point_location;
  if (!location) return true;

  return (
    !location.address &&
    !location.city &&
    !location.province &&
    !location.country &&
    !location.postal
  );
}
